<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">油耗检测设备</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 74%" class="oneBodyImgCls" src="../../assets/images/vtyhv1_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">油耗检测设备</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          本产品是富从研发支持嵌入式系统的智能油耗检测设备，应用超声波测量技术对油箱内的油位高度进行测量，并经过电路处理后输出标准电信号。超声波传感器外贴于油箱底部，无须与油直接接触即可对油位高度实时检测。同时支持油浮子的模拟量检测输入，广泛应用于各类车辆油量检测及监控，结合GPS/GPRS通讯技术，通过后台软件管
          理平台，实现对车辆用油科学管 理，防止偷油行为，节约车辆营运成本。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">金属壳体+连接器：84mm(长)*75mm(宽)*25mm(高)</div>
      <div class="center_two_e">金属壳体：84mm(长)*60mm(宽)*25mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        车辆
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">测量<br/>准确</div>
        <div class="three_body_left_right">测量精度为1mm，超声波传感器在－40℃到80℃间进行了温度校正，确保设备在高温及低温的外部 环境正常运行，并采集准确数据；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">稳定<br/>性好</div>
        <div class="three_body_right_right">采用最新的超声波非接触测量技术，本产品无需与油接触，相对于传统采用的直接接触式、浮子式、压力式、 磁制滑动式测量方法；更能保证产品的稳定性、长寿命；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">安装<br/>简单</div>
        <div class="three_body_left_right">只需将传感器安装在油箱外部下方即可，无需改变原有油箱结构；采用国际标准的RS232串口接口方式；</div>
      </div>

      <div class="center_three_body_right" style="margin-bottom: 48px">
        <div class="three_body_right_left_double">实用<br/>性强</div>
        <div class="three_body_right_right">产品可安装在12V/24V 大小工程车辆上使用，也可安装在圆形和方形油箱底部。</div>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 393px;

    .oneBodyImgCls {
      width: 100%;
      height: 393px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 453px;

    .oneBodyImgCls {
      width: 100%;
      height: 453px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 590px;

    .oneBodyImgCls {
      width: 100%;
      height: 590px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>